const o = (s) => {
  var i, e;
  return s.style.cssText ? ((e = (i = s.style.cssText.split(";").map((t) => t.trim()).find((t) => t.startsWith("width"))) == null ? void 0 : i.split(":")[1]) == null ? void 0 : e.trim()) ?? "auto" : "auto";
};
export {
  o as getContainerWidthFromElement
};
